<template>
    <split-pane  :min-percent='10' :default-percent='12' split="vertical"  style="background:white; height:100%">
        <template slot="paneL">
            <el-input :placeholder="$LANG('1779', '请输入关键字进行过滤')" v-model="filterText" size="medium"  ></el-input>
            <el-tree :data="accData" 
                        :props="defaultProps" 
                        @node-click="handleNodeClick" 
                        node-key="id"                       
                        :style="{height: scrollerHeight,overflow:'auto',display: 'flex',padding:15}"
                        highlight-current
                        :filter-node-method="filterNode"
                        v-loading="loadingtree"
                        :element-loading-text="$LANG('1959', '加载中')"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(255, 251, 255, 0.8)"   
                        ref="eltree"
                        default-expand-all
                        :expand-on-click-node="false">
                <template v-slot="{node,data}">                                     
                    <span v-if="data.id ==0 "  class="nodeRoot" >
                     <i class="iconfont   icon-kucunguanli" style="color:#409eff;font-size:16px;margin-right:3px;"></i>
                     <span class="nodeLabel" style="font-size:14px;font-weight:600;color:#409efe">{{ node.label}} </span>
                    </span>                  
                    <span v-else > 
                       <span style="color:#2b85e4;font-size:12px;"> <i class="iconfont icon-fenzhijiedian" style="color:#409eff;font-size:14px;margin-right:3px;"></i> {{ node.label}} </span>
                    </span>
                </template>
            </el-tree>
        </template>  
        <template slot="paneR">
            <div class="ve-list-page ve-list-page--embedded ve-list-page--pane">
            <div style=" display:flex; width:100%; background:#fff;line-height:30px;height:40px;  border-bottom:2px solid #389">
                <div style="min-width:1100px;display:flex;padding-top:3px"> 
                    <div style="width:70px">
                        <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                        <el-link :disabled="addBool"  @click="addRec" :underline="false" ><span style="font-size:12px;margin-right:15px;">{{ $LANG('0138', '新增') }} </span></el-link>
                    </div>
                    <el-select v-model="selparam"  :placeholder="$LANG('1675', '请选择列名')" clearable size="small" style="width:150px; ">
                        <span v-for="item in tabArr" :key='item.key'>
                            <el-option :label="item.title" :value="item.key" style="width:150px;"></el-option>
                        </span>
                    </el-select>
                    <el-input :placeholder="$LANG('1692', '请输入查询值')" v-model="txtparam" size="small" style="width:320px; height:30px;  ">
                        <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                        <div slot="prepend">
                            <el-select v-model="oper" slot="prepend"   style="width:100px; " size="small">
                                <span v-for="item in operArr" :key='item.IDSEQ'>
                                    <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                                </span>
                            </el-select>
                        </div>
                    </el-input> 
                    <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                    <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
                </div> 
            </div>
            <div class="ve-list-page__table">
            <ve-table :columns="vueCol"
                    :table-data="tabData"
                    :columnHiddenOption="columnHiddenOption"
                    :border-around="true"
                    :border-x="true"
                    :border-y="true"
                    :fixed-header="true"
                    :scroll-width="0"
                    row-key-field-name="IDSEQ"
                    :row-style-option="rowStyleOption"
                    :cell-style-option="cellStyleOption"
                    :event-custom-option="eventCustomOption"
                    :max-height="tabHeight"
                    :virtual-scroll-option="virtualScrollOption"
                    :column-width-resize-option="columnWidthResizeOption"
                    :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                    :cellSelectionOption="{enable: false}"
                    ref="tabref">
            </ve-table>
            </div>
            <VeColumnConfigDialog
                :visible="fieldSettingDialog.visible"
                :rows="fieldSettingDialog.rows"
                :loading="fieldSettingDialog.loading"
                :error="fieldSettingDialog.error"
                :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
                :drag-group-field="fieldSettingDialog.dragGroupField"
                :language="$store.state.lang"
                @update:visible="fieldSettingDialog.visible = $event"
                @change="updateFieldSettingsDraft"
                @confirm="saveFieldSettingsDialog"
                @reset="resetFieldSettingsDialog"
                @close="closeFieldSettingsDialog"
            />
            <div style="height: 35px;margin-top:5px; overflow: hidden;display:flex;background:white;font-size:12px;line-height:30px" class="ve-list-page__pagination">
                <div style="float: left;padding-left:5px">
                    <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
                </div>
            </div> 
            <el-dialog :visible.sync="addModal" width="800px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{addFlag==='create'?$LANG('0095', '新增记录'):$LANG('0921', '编辑记录')}}</span>
                </div> 
                <Form ref="addForm" :model="formCol" :label-width="120"    label-position="right" inline >
                    <span v-for="(item,index) in tabArr" :key="index" >
                        <FormItem class="item-width"  :label="item.title" :prop="item.key" v-if="item.fhide==='N'">                                  
                            <el-input :placeholder="item.holder" :disabled="saveFlag" v-enter-number  v-if="item.edcss==='number'" v-model="formCol[item.key]" style="width:100%" ></el-input>   
                            <el-checkbox border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="formCol[item.key]" style="width:100%"></el-checkbox> 
                            <el-input type="text" v-else-if="item.key==='SUBJECTNM'" disabled  v-model="formCol[item.key]">
                                <div slot="append">
                                    <el-button @click="subChoose" icon="iconfont icon-icon-choose" style="width:50px;color:blue;font-weight:600;font-size:22px;"></el-button>
                                </div>
                            </el-input>
                            <el-input :placeholder="item.holder" type="text" v-else :disabled="item.disabled==='Y'?true:false||saveFlag "  v-model="formCol[item.key]"></el-input>
                        </FormItem>
                    </span>
                </Form>   
                <div style="line-height:30px;font-weight:600;font-size:14px;color:red">
                    {{ $LANG('2075', '提示：收支编码默认为系统自动生成，也可修改') }}
                </div>                  
                <div slot="footer">
                    <el-button type="text" icon="iconfont icon-shanchu"  @click="addModal=false" style="margin-right:50px;">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button type="text" icon="iconfont icon-baocun"  @click="modal_ok" style="margin-right:10px;">{{ $LANG('1638', '确定') }}</el-button>
                </div>
            </el-dialog>
            <el-dialog :visible.sync="promptWin" width="450px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
                </div> 
                <span>{{prompt}}</span>
                <span slot="footer"  >
                    <el-button size="small" type="primary" @click="promptWin = false">{{ $LANG('1638', '确定') }}</el-button>
                </span>
            </el-dialog>
            <!-- 选择科目 -->
            <el-dialog :visible.sync="subWin" width="700px" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;"> {{ $LANG('0897', '科目类别') }}</span>
                </div> 
                <div style="height:90vh;overflow-y:auto"><subjectSel @child-subject="subOk"></subjectSel></div>
            </el-dialog>
        </div>
        </template>     
    </split-pane> 
</template>

<script>
  import subjectSel from '../datamgt/subject.vue'
  import { getTabColOrData,getBaseData } from '../../api/user'
  import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
  import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
  import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
  import { buildVeTableFieldCondition, buildVeTableHeaderCondition } from '@/utils/veTableHeaderQuery'
  export default {
    name: 'type_inout',
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '15900',
            fieldIdseq: '15900',
            fieldLstseq: '1',
            mainColumnKey: 'tabArr',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'tabref',
            generatedFixedColumnKeys: ['rownum', 'oper'],
        })
    ],
    components: {
        subjectSel, //科目选择
        VeColumnConfigDialog,
    },
    data() {
      return {
        promptWin:false,
        prompt:'',
        subWin:false,
        addModal:false, //modal 
        formCol:{}, //表格单行记录 model
        accData:[] , //树结构数据
        oper:'like',
        selparam:'',
        txtparam:'',
        operArr:[],
        loadingtree:false,
        filterText: '',
        defaultProps: {  //el-tree 默认字段属性
            children: 'children',
            id:'id',
            icon:'icon',
            parentid:'',
            label: 'label'
        },
        ruleValidate:{}, //校验规则
        addFlag: 'create',
        nodeLabel:this.$cookies.get('v_corpnm'),
        treeid :'0',
        parentid:'',
        allData:[],
        tabData:[],
        tabArr:[],
        initCol:[],
        vueCol:[],
        columnHiddenOption: { defaultHiddenColumnKeys: [] },
        rowStyleOption: { clickHighlight: true },
        cellStyleOption: { headerCellClass: () => 'table-head-cell-class', bodyCellClass: () => 'table-body-cell-class1' },
        v_headerRow:{},
        queryRequestId:0,
        virtualScrollOption: { enable: false },
        eventCustomOption: {
            bodyRowEvents: ({ row }) => ({ click: () => this.rowClick(row) }),
        },
        saveFlag:false,
        v_url:'xuper_auth/getTableRecMany' , //api请求路径
        addBool:false, //新增,为true时--禁止
        editBool:false, //编辑,为true时--禁止
        delBool:false, //删除 ,为true时--禁止
        cfmBool:false, //审核 ,为true时--禁止
        cancelBool:false, //作废 ,为true时--禁止 
        v_admin:this.$cookies.get('v_admin') ,//      
        v_username:this.$cookies.get('v_telno'), //api 请求用户
        
        v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
        dataCount:0,
        rowSize:50,
        goPage:'',
        current:1,
        pageList: [ {
            value: 50,
            label: '50'
            }, {
            value: 100,
            label: '100'
        }],
      }
    },
    watch: {
        filterText(val) {
            this.$refs.eltree.filter(val);
        }
    },
    created () {
        if(this.v_username){
            this.getData() //左边树
            this.getTabField() // 字段集
            this.getAccList(' and parentno=\''+this.treeid+'\'')  
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    mounted () {
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        //用户表单新增、编辑、审核、作废权限 :frmid:94供应商资料ID
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','4190','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                console.log(JSON.stringify(row))
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        }) 
    },
    computed:{
            scrollerHeight: function() {
                return (window.innerHeight - 128) + 'px';
            },
            tabHeight: function() {
                return (window.innerHeight - 163) + 'px';
            }, 
        },
    methods: {
        //科目选择
        subOk(idseq,accnm){
            this.formCol['SUBJECT']=idseq
            this.formCol['SUBJECTNM']=accnm
            this.subWin=false
        },
        subChoose(){
            this.subWin=true
        },
        //查询
        qryTabData(){
            let cond_=buildVeTableHeaderCondition(this.initCol, this.v_headerRow)
            cond_+=buildVeTableFieldCondition(this.initCol, this.selparam, this.txtparam, this.oper)
            this.current = 1
            this.getAccList(' and parentno=\''+this.treeid+'\' '+cond_)
        },
        rowShow(){
            this.v_headerRow = {}
            this.qryTabData()
        },
        getRowKey(row){
            return row.IDSEQ
        },
        rowClick(row){

        },
        editRec(row,val){
            this.formCol =JSON.parse(JSON.stringify(row))
            this.addModal=true 
            this.addFlag='edit'
        },
        //跳至页面
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.promtWin=true
                this.prompt=this.$LANG('1721', '请输入跳至页数')
            }
        },
        //客户明细
        getAccList(cond){
            const requestId = ++this.queryRequestId
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'', p_value:'',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond,p_table:'V_AC_iotype'},
            }).then(res=>{ 
                if (requestId !== this.queryRequestId) return
                if (res.code==='200'){
                    this.allData =res.result
                    this.initPage() 
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
                this.$nextTick(() => {
                    const table = this.$refs.tabref
                    if (table && typeof table.doLayout === 'function') table.doLayout()
                })
            }).catch((error) => {
                if (requestId === this.queryRequestId) { this.promptWin=true; this.prompt=error.message || this.$LANG('1641', '查询失败') }
            })
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
                this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize;
            this.tabData = this.allData.slice(_start,_end);
        },
        //确定 保存
        modal_ok(){
            //发起保存请求   
            if (this.formCol['CNAME']){
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(Object.assign(this.formCol,{CORPID:this.v_corpid})), p_table:'AC_IOTYPE',p_frmid:''},
                }).then(res=>{   
                    console.log('form:'+JSON.stringify(this.formCol))      
                    if(res.code ==='200')  {     
                        this.addModal =false   
                        this.getAccList(' and parentno=\''+this.treeid+'\'') 
                        this.getData()      
                    }else{
                        this.prompt=res.result
                        this.promptWin=true
                    }        
                }) 
            }else{
                this.promptWin=true
                this.prompt=this.$LANG('0076', '收支类别')+this.$LANG('0282', '名称')+this.$LANG('2051', '不能为空')
            }
        } ,
        //新增
        addRec(){  
            this.$axios({ //取到最大IDNO +1
                method: 'post',
                url:'xuper_auth/getMaxNum',
                data: {p_key:'idno',p_value:"1000",p_key2:'corpid',p_value2:this.v_corpid, p_table:'ac_IOTYPE'},
            }).then(res=>{      
                if(res.code =='200')  {  
                    this.addModal =true
                    this.addFlag ='create'
                    this.formCol ={IDSEQ:'',IDNO:res.result,PARENTNO:this.treeid,PCNAME:this.nodeLabel,STFG:'N'}     
                }else{
                    this.prompt=res.result
                    this.promtWin=true
                }        
            })               
        },
 
        //节点过滤
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        //节点点击
        handleNodeClick(data){
            this.nodeLabel=data.label;            
            this.treeid =data.id
            this.parentid=data.parentid
            this.getAccList(' and parentno=\''+data.id+'\'')
        },
 
        //删除记录
        delRec(row){
            this.$confirm(this.$LANG('1594', '你确定要删除此行记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                //发起删除请求
                var vm=this;
                //选判断有没子节点
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_key:'parentno',p_value:row.IDNO,p_key2:'corpid',p_value2:this.v_corpid,p_table:'v_AC_IOTYPE'},
                }).then(res=>{  
                    if (res.result.length===0){
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/delTabRec',
                            data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'ac_IOTYPE'},
                        }).then(res=>{      
                            if(res.code =='200')  {           
                                vm.getData()   
                                vm.getAccList(' and parentno=\''+this.treeid+'\'')     
                            }else{
                                this.promptWin=true
                                this.prompt=res.result
                            }        
                        }) 
                    }else{
                        this.promptWin=true
                        this.prompt=this.$LANG('1555', '存在子记录,不能删除')
                    }
                })      
            }).catch(()=>{})
        },
        // 获取 树形控件数据
        getData() {   
            var vm=this;
            this.loadingtree=true
            this.$axios({
                method: 'post',
                url:'xuper_auth/getElTreeData',
                data: {p_table:'V_IOTYPE_MENU',p_cond:' and ( corpid=\''+this.v_corpid+'\')'}
            }).then(function(res){ 
                if (res.code==='200'){                 
                    vm.accData =res.result;  
                    vm.$nextTick(()=>{ //必须要放在nexttick里，要不然还未渲染上
                        vm.$refs.eltree.setCurrentKey(vm.treeid)
                    })
                } else{
                    vm.promptWin=true
                    vm.prompt=res.result
                }  
                vm.loadingtree=false          
            })                            
        },
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','15900','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                vm.initCol = res.result
                return vm.loadInitialFieldSettings().then(() => {
                    const fieldRows = vm.sortFieldRows(vm.initCol)
                    vm.tabArr = []
                    vm.vueCol = []
                    fieldRows.forEach(item => {
                        vm.tabArr.push({
                            title: vm.$translate.getColTitle(item, vm.$store.state.lang),
                            key: item.key,
                            align: item.align,
                            width: item.width,
                            edcss: item.EDCSS,
                            thide: item.THIDE,
                            holder: item.HOLDER,
                            fhide: item.FHIDE,
                            disabled: item.DISABLED,
                        })
                        if (item.THIDE !== 'N') return
                        vm.vueCol.push({
                            field: item.key,
                            key: item.key,
                            title: vm.$translate.getColTitle(item, vm.$store.state.lang),
                            align: item.align,
                            width: Number(item.width) || 120,
                            sortable: item.key !== 'RN' && item.EDCSS !== 'checkbox',
                            ellipsis: { showTitle: true },
                            renderHeaderCell: ({column}) => <VeTableQueryHeader title={column.title} edcss={item.EDCSS} value={this.v_headerRow[item.key]} operator={this.v_headerRow[`#OPER${item.key}`]} on-input={(value) => this.$set(this.v_headerRow, item.key, value)} on-operator-change={(value) => this.$set(this.v_headerRow, `#OPER${item.key}`, value)} on-query={this.qryTabData} />,
                            renderBodyCell: ({row}) => item.EDCSS === 'checkbox'
                                ? <el-checkbox disabled true-label="Y" false-label="N" v-model={row.STFG}></el-checkbox>
                                : row[item.key],
                        })
                    })
                    vm.vueCol.unshift({
                        field: 'index', key: 'rownum', title: vm.$LANG('0310', '序号'), width: 55, align: 'center', fixed: 'left', disableResizing: true,
                        renderHeaderCell: ({column}) => <div><div style="margin-top:3px">{column.title}</div><el-link on-click={this.rowShow} style="font-size:12px;color:#404eff;height:30px"><el-tooltip content={this.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip></el-link></div>,
                        renderBodyCell: ({rowIndex}) => rowIndex + 1,
                    })
                    vm.vueCol.push({
                        field: 'oper0',
                        key: 'oper',
                        title: vm.$LANG('0330', '操作'),
                        width: 165,
                        align: 'center',
                        fixed: 'right',
                        disableResizing: true,
                        renderBodyCell: ({row}) => (
                            <div>
                                <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link disabled={vm.editBool} on-click={() => vm.editRec(row, 'N')} underline={false}><span style="font-size:11px;margin-right:15px;">{vm.$LANG('1639', '编辑')}</span></el-link>
                                <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link disabled={vm.delBool} on-click={() => vm.delRec(row)} underline={false}><span style="font-size:11px;margin-right:10px;">{vm.$LANG('0131', '删除')}</span></el-link>
                            </div>
                        ),
                    })
                    vm.applyFieldSettingRows()
                })
            })
        }
    }
  }
</script>
<style scoped>
 .siderCls{
     background:#fff;
     margin: 3px auto;
     width: 260px;
     min-width: 260px;
     max-width:260px;
     border-right: 2px solid #C0C4CC;
}
    .item-width  {
        width: 48%;
    } 
.headbar{
    padding-left:5px; 
    line-height:40px;
    background:#fff;
    overflow: auto;
    padding-top:2px;
    display:flex;
    border-left:2px solid #409eff;
}
.treeCss{
    padding-left:5px; 
    width:100%;
    background:#fff;
    margin:2px auto ;
    margin-top:5px;
   overflow:auto;
   height: calc(100vh - 130px);
}
.nodeLabel{
        font-size:12px;
        font-weight:500;
        padding-left:10px;
        color: black;
    }
.nodeRoot{
        width:20px;
        font-size:14px;
        font-weight:600;
    }  
.top{
        padding: 10px;
        background: rgba(0, 153, 229, .7);
        color: #fff;
        text-align: center;
        border-radius: 2px;
    }        
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{  //用于表格中checkbox disabled时为蓝色
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-tree-node.is-current > .el-tree-node__content {
      background-color: #f3b6b6 !important;
      color:rgb(30, 44, 90);
    }
    .el-tree-node__content:hover {    
      background-color: #66b1ff87;
    }
    .tree-scroll{
        width :180px;
        border: 1px solid #f5dbdb;
        height: 100%;
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
